import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dynamic-switchery',
  templateUrl: './dynamic-switchery.component.html',
  styleUrls: ['./dynamic-switchery.component.scss']
})
export class DynamicSwitcheryComponent implements OnInit, OnChanges {
  private _item: boolean;
  @Input() 
  set item(value: boolean) {
    this._item = !!value;
    this.localItem = !!value;
  }
  get item(): boolean {
    return this._item;
  }

  @Input() label: string;
  @Input() trueValue?: string;
  @Input() falseValue?: string;
  @Input() disable?: boolean = false;
  @Input() tooltip?: string;

  @Output() newSwitchEvent = new EventEmitter<boolean>();

  // Local state to avoid issues with @Input + ngModel
  localItem: boolean = false;

  constructor() { }

  ngOnInit(): void {
    // Initialize localItem with the input value
    this.localItem = !!this.item;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Sync localItem with item input when it changes from parent
    // This handles the initial value and any external updates
    if (changes['item']) {
      this.localItem = !!changes['item'].currentValue;
    }
  }

  onSwitchChange(newValue: boolean): void {
    this.localItem = newValue;
    this.newSwitchEvent.emit(newValue);
  }
}
